import React from "react"

const Users = ({ width="69", height="56", viewBox="0 0 69 56" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-users-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.005 21.143c0 2.84-2.418 5.143-5.401 5.143-2.983 0-5.402-2.303-5.402-5.143S25.621 16 28.604 16s5.401 2.302 5.401 5.143Zm8.103-1.714c-2.486 0-4.502 1.918-4.502 4.285S39.622 28 42.108 28c2.486 0 4.501-1.919 4.501-4.286 0-2.367-2.015-4.285-4.501-4.285Zm-3.69 13.13c-.917-1.746-2.793-2.849-4.844-2.845h-9.94c-2.05-.004-3.927 1.099-4.843 2.846l-2.593 4.954c-.28.53-.253 1.162.074 1.668.326.507.905.816 1.529.818h21.607a1.822 1.822 0 0 0 1.529-.818 1.643 1.643 0 0 0 .073-1.668l-2.593-4.954Zm11.684 1.698 1.71 3.257c.282.531.254 1.162-.072 1.669a1.822 1.822 0 0 1-1.53.817h-5.707a4.92 4.92 0 0 0-.27-4.011l-2.395-4.56h3.439c2.04 0 3.907 1.093 4.825 2.828Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-users-icon"
          x="-6"
          y="-12"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.558333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Users